export const APP_ROUTES = {
  catchAll: '*',
  root: '/',
} as const;
